import React from 'react';

// const sections = [
//   { id: 'ref-SUBJECTIVE-CC', label: 'CC' },
//   { id: 'ref-OBJECTIVE-Vitals', label: 'V' },
//   { id: 'ref-ASSESSMENT-P', label: 'P' },
//   { id: 'ref-PLAN-N', label: 'ON' },
//   { id: 'ref-AdditionalINFO-DOC', label: 'DOC' },
// ];

const SectionScrollNavigator = ({ encounterID, activeID, setActiveID, hoveredItem, setHoveredItem, ...props }) => {
  let { defaultSelectedItems } = props; 
  let { historyofPresentIllness, reviewOfSystem, vitals, problems, otherNote, followUp, documents, additionalNotes } = defaultSelectedItems;
  console.log("additionalNotes123", documents, additionalNotes)
  const handleScrollIntoView = (id) => {
        setActiveID(id);
        setHoveredItem('');
    const element = document.getElementById(id);
    if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
        //onNavigate?.(id); // Optional callback
    }
  };

  const insertPosition = props?.customTemplateData?.[0]?.InsertPosition || '';
  const sections = [
    ...(insertPosition === 'Top' ? 
      [{  id: `ref-CF${encounterID}`, label: 'CT' }] : []
    ),
    { id: `ref-SUBJECTIVE-CC${encounterID}`, label: 'CC' },
    ...(historyofPresentIllness ? [{ id: `ref-SUBJECTIVE-HPI${encounterID}`, label: 'HPI' }] : []),
    ...(reviewOfSystem ? [{ id: `ref-SUBJECTIVE-ROS${encounterID}`, label: 'ROS' }] : []),
    // { id: `ref-SUBJECTIVE-CC${encounterID}`, label: 'CC' },
    ...(vitals ? [{ id: `ref-OBJECTIVE-Vitals-${encounterID}`, label: 'V' }] : []),
    // { id: `ref-OBJECTIVE-Vitals-${encounterID}`, label: 'V' },
    ...(problems ? [{ id: `ref-ASSESSMENT-P-${encounterID}`, label: 'P' }] : []),
    // { id: `ref-ASSESSMENT-P-${encounterID}`, label: 'P' },
    // ...(otherNote ? [{ id: `ref-PLAN-N-${encounterID}`, label: 'ON' }] : []),
    { id: `ref-PLAN-N-${encounterID}`, label: 'ON' },
    ...(followUp ? [{ id: `ref-PLAN-FollowUp${encounterID}`, label: 'F' }] : []),
    // ...(documents ? [{ id: `ref-AdditionalINFO-DOC-${encounterID}`, label: 'DOC' }] : []),
    ...(insertPosition === 'Bottom' ? 
      [{  id: `ref-CF${encounterID}`, label: 'CT' }] : []
    ),
    ...(documents || additionalNotes) ?
    [{
      label: 'AI',
      heading: `ref-AdditionalINFO${encounterID}`,
      children: [
        ...(documents ? [{ id: `ref-AdditionalINFO-DOC${encounterID}`, label: 'DOC' }] : []),
        ...(additionalNotes ? [{ id: `ref-AdditionalINFO-N${encounterID}`, label: 'N' }] : []),
      ],
    }] : [],
    // { id: `ref-AdditionalINFO-DOC-${encounterID}`, label: 'DOC' },
  ];
  return (
    <>
      {sections.map((section, index) => (
        <>
        <div className="d-flex flex-column gap-5" key={index}>
        {section?.children?.length > 0 ?
          (<>
            <p
              id={`vertical-bar-${section.id}`}
              className={`heading text-center ${
              section.children
                ? [section.id, ...section.children.map(c => c.id)].includes(activeID)
                  ? 'orange-drk'
                  : ''
                : activeID === section.id  ? 'orange-drk' : ''
            }`}
              onClick={() => handleScrollIntoView(section.heading)}
            >
              {section.label}
            </p>
            {section?.children?.map((child) => (
              <p
                key={child.id}
                id={`vertical-bar-${child.id}`}
                className={`box font-m text ar-light-color ${
                  activeID === child.id ? 'active' : ''
                } ${
                  hoveredItem === child.id ? 'active' : ''
                }`}
                onClick={() => handleScrollIntoView(child.id)}
              >
                {child.label}
              </p>
            ))}
          </>): 
          (<p
            key={section.id}
            id={`vertical-bar-${section.id}`}
            className={`box font-m text ar-light-color ${
              activeID === section.id ? 'active' : ''
            } ${
              hoveredItem === section.id ? 'active' : ''
            }`}
            onClick={() => handleScrollIntoView(section.id)}
          >
            {section.label}
          </p>)
          }
          </div>
        </>
      ))}
    </>
  );
};

export default SectionScrollNavigator;